/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface PropertyValueOut {
  property_id: string;
  key: string;
  name: string;
  type: string;
  value: unknown;
  source: string;
  set_at: string;
}
